import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon } from 'lucide-react';
import { consultants } from '../../data/consultants';
import { ConsultantAvatar } from './ConsultantAvatar';
interface ConsultantContactListProps {
  columns?: 1 | 2;
}
export function ConsultantContactList({
  columns = 2
}: ConsultantContactListProps) {
  return <ul className={`grid gap-x-10 border-t border-plum/10 ${columns === 2 ? 'md:grid-cols-2' : ''}`} data-id="element-69" data-mp="36sxjug1tkcqe">
      {consultants.map(consultant => <li key={consultant.slug} className="flex items-center gap-4 border-b border-plum/10 py-5" data-id="element-70" data-mp="3fnu361f975rz">
          <ConsultantAvatar consultant={consultant} size="sm" data-id="element-71" data-mp="3ul4jpp6r71uk" />
          <div className="min-w-0 flex-1" data-id="element-72" data-mp="3ui8nc5ak0l88">
            <Link to={`/consultants/${consultant.slug}`} className="font-display font-semibold text-aubergine hover:text-copper-deep" data-id="element-73" data-mp="3pl8exnq8f6dy">
              {consultant.name}
            </Link>
            <p className="text-xs text-plum/60" data-id="element-74" data-mp="1v80glm31scnk">{consultant.title}</p>
            <a href={`mailto:${consultant.email}`} className="mt-1 inline-flex items-center gap-1.5 text-sm font-semibold text-copper-deep hover:underline" data-id="element-75" data-mp="1v9trxeolvl1w">
              <MailIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-76" data-mp="1v5o4iu85qi3n" />
              Email {consultant.firstName}
            </a>
          </div>
        </li>)}
    </ul>;
}